import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f441da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.nft.onchainMetadata.data.creators != null && (_ctx.nft.onchainMetadata.data.creators[0].address == 'ACN6FeoHTPjzHretcRSfV9T2NGU6SedkQwgiL1P3YQR8' || _ctx.nft.onchainMetadata.data.creators[0].address == 'DynFnTUjzoXPDtAGg9mN6kF3L4oweR8Wau4DhcDwd5TU' || _ctx.nft.onchainMetadata.data.creators[0].address == '2tMAZT6cdFLfUdbcSWQniPVvn85tmWdHCUxgg65zfxU2' || _ctx.nft.onchainMetadata.data.creators[0].address == '6Y3DKHgWX5tU6S4smXt9mstrEzn4krEyibqbn16LgFe7'))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["m-1 card flex justify-center", { 'card-selected': _ctx.selected }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.nft.externalMetadata.image,
          alt: _ctx.nft.onchainMetadata.data.name
        }, null, 8, _hoisted_1)
      ], 2))
    : _createCommentVNode("", true)
}